import React from "react";
import styled from "styled-components";

import { useIntl } from "../../../../../shared/core/i18n/use-intl";
import { MANDATES_STATUSES } from "../../../../../shared/domains/mandates/mandate";
import { getMandateStatusStyles } from "../../../../../shared/domains/mandates/status-color";
import { theme } from "../../../styles/theme";

export const MandateStatusPill = ({ status }: { status: string }) => {
  const { formatMessage } = useIntl();
  const matchingStatus = MANDATES_STATUSES[status];
  const style = matchingStatus?.color && getMandateStatusStyles(matchingStatus?.color, theme);

  return <StyledMandateStatusPill style={style}>{formatMessage(matchingStatus.label)}</StyledMandateStatusPill>;
};

const StyledMandateStatusPill = styled.div`
  ${theme.mediumText}
  font-size: 12px;
  display: flex;
  align-items: center;
  padding: 4px 10px 4px 7px;
  border-radius: 20px;
  &::before {
    content: "";
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 5px;
    background-color: currentColor;
  }
`;
